<div class="annotations-parent">
    <div class="annframe-container">
        
        <div class="main-annotaion">
            <section *ngIf="isOldUniprotEntry" class="notification">
                <notification-msg 
                    [type]="'warning'" 
                    [message]="'This AlphaFold model was generated using a prior version of the UniProt sequence.'">
                </notification-msg>
            </section>
            <app-heatmap
                [accession]="accession"
                [amAnnotationsHg19Url]="entryData().amAnnotationsHg19Url"
                [amAnnotationsHg38Url]="entryData().amAnnotationsHg38Url"
                [csvAMFileUrl]="entryData().amAnnotationsUrl"
                [heatmapSequence]="entryData().sequence"
                [csvAmData]="csvAmData()"
                [plddtData]="plddtData"
                [colorScheme]="colorScheme"
                (onChangeColor)="updateColorScheme($event)"
                (onProtvistaMouseEvent)="triggerMolstarEvents($event)"
                (selectedCategory)="amSelectionCategory($event)"
                (selectedRegion)="amSelectionUpdate($event)"
                (clearRegion)="amSelectionClear()"
                *ngIf="csvAmData"
            ></app-heatmap>

        </div>
       
        <div class="main-structure">
            <div class="legends" *ngIf="colorScheme.includes('plddt')">
                <linear-legends type="plddt"></linear-legends>
            </div> 
            <div class="legends" *ngIf="colorScheme.includes('missense')">
                <linear-legends type="missense"></linear-legends>
            </div> 
            <div class="legends" *ngIf="colorScheme.includes('custom')">
               <div style="height: 43px;"></div>
            </div> 
            <!-- <div *ngIf="dropdownSelected.includes('Domain')">
                <div
                [ngClass]="{ 'scrollable-body': tedDomainData().length > 5, 'non-scrollable-body': tedDomainData().length <= 5 }">
                    <div *ngIf="tedDomainData().length > 0" class="legend-title">TED</div>
                    <div class="modelInfo">
                        <div *ngIf="tedDomainData().length > 0" class="confidenceWrapper">
                            <div
                                class="column legendRow"
                                *ngFor="let ted of slicedTedDomain(); index as i">
                                <span class="legendColor"
                                [style.background]="utilService.fetchColorByIndex(i)">&nbsp;</span>
                                <span class="legendlabel">Domain {{ ted.ted_domain_no }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  -->
            <div class="annotations-molstar-container"></div>
            <div class="paecontainer">
    
                <app-pae-view *ngIf="entryData().paeDocUrl" 
                    [accession]="accession" [paeid]="'annotations-paeviewer'"
                    [paeDocUrl]="entryData().paeDocUrl" 
                    [imageUrl]="entryData().paeImageUrl" 
                    [length]="entryData().sequenceEnd"
                    (selectedRegion)="cmSelectionUpdate($event)">
                </app-pae-view>
            </div>
        </div>
    </div>
</div>